import { render } from "./GraduationCapIcon.vue?vue&type=template&id=1f04467f"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/GraduationCapIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f04467f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f04467f', __exports__)) {
    api.reload('1f04467f', __exports__)
  }
  
  module.hot.accept("./GraduationCapIcon.vue?vue&type=template&id=1f04467f", () => {
    api.rerender('1f04467f', render)
  })

}


export default __exports__